import * as tslib_1 from "tslib";
import { OnChanges, OnInit } from '@angular/core';
import { AviationEventType, AviationEventTypeDesc } from '../models/aviation-event.model';
import { AviationEventsService } from '../services/aviation-events.service';
import { LatLon } from '../../util/geodesy/latlon';
import * as moment from 'moment-timezone';
var NearbyEventsComponent = /** @class */ (function () {
    function NearbyEventsComponent(_aviationEventsService) {
        this._aviationEventsService = _aviationEventsService;
        this.eventId = null;
        this.isLoading = false;
        this.aviationEventTypeDesc = AviationEventTypeDesc;
        this.aviationEventType = AviationEventType;
    }
    NearbyEventsComponent.prototype.getDateString = function (aviationEvent, dateType) {
        var eventDate;
        if (dateType === 'start') {
            eventDate = moment.tz(aviationEvent.startDateTime, 'UTC');
        }
        else {
            eventDate = moment.tz(aviationEvent.endDateTime, 'UTC');
        }
        var eventDateString = eventDate.clone().tz(aviationEvent.timezone).format('MM/DD/YYYY');
        return eventDateString;
    };
    NearbyEventsComponent.prototype.filterAviationEvents = function (aviationEvents) {
        var _this = this;
        aviationEvents = aviationEvents.filter(function (ae) {
            if (ae.format === 'Online' || (_this.eventId && ae.eventId === _this.eventId)) {
                return false;
            }
            else {
                return true;
            }
        });
        return aviationEvents;
    };
    NearbyEventsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!(this.lat != null && this.lon != null)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._aviationEventsService.getAviationEventsByLatLon(new LatLon(this.lat, this.lon), 100)];
                    case 1:
                        _a.aviationEvents = _b.sent();
                        this.aviationEvents = this.filterAviationEvents(this.aviationEvents);
                        _b.label = 2;
                    case 2:
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    NearbyEventsComponent.prototype.ngOnChanges = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!(this.lat != null && this.lon != null)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._aviationEventsService.getAviationEventsByLatLon(new LatLon(this.lat, this.lon), 100)];
                    case 1:
                        _a.aviationEvents = _b.sent();
                        this.aviationEvents = this.filterAviationEvents(this.aviationEvents);
                        _b.label = 2;
                    case 2:
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return NearbyEventsComponent;
}());
export { NearbyEventsComponent };
